import React, { useEffect, useState } from 'react';
import { clearLog, getLog, subscribe } from './debugLog';
import { buildReport, copyReport, downloadReport } from './report';

// Shown on the front page only when the address has ?debug
function DebugPanel() {
  const [log, setLog] = useState(getLog());
  const [note, setNote] = useState('');

  useEffect(() => subscribe(() => setLog(getLog())), []);

  const flash = (text) => {
    setNote(text);
    setTimeout(() => setNote(''), 3000);
  };

  const download = async () => {
    downloadReport(await buildReport({ kind: 'front-page' }));
    flash('report downloaded');
  };

  const copy = async () => {
    flash((await copyReport(await buildReport({ kind: 'front-page' }))) ? 'report copied' : "couldn't copy: use download instead");
  };

  return (
    <section className="ms-box fm-debug" aria-labelledby="debug-title">
      <h2 className="ms-box-title" id="debug-title">🐞 Debug: player events</h2>
      <div className="ms-box-body">
        <p className="ms-hint">
          Debug mode is on (the address ends in <code>?debug</code>). Download the report and send it to Claude.
          It contains these events plus technical details about this browser, but nothing personal.
        </p>
        <div className="fm-player-controls">
          <button type="button" className="ms-btn" onClick={download}>download report</button>
          <button type="button" className="ms-btn" onClick={copy}>copy report</button>
          <button type="button" className="ms-btn" onClick={clearLog}>clear log</button>
          <a className="ms-link" href="/ytlab">run the embed lab ↗</a>
          {note && <span role="status" className="ms-status">{note}</span>}
        </div>
        <div className="ms-results fm-debug-log" tabIndex={0} role="log" aria-label="Player event log">
          {log.length === 0 && <div className="ms-empty">nothing logged yet</div>}
          {log.map((entry, index) => (
            <div key={index} className="fm-debug-row">
              <span className="fm-debug-time">{(entry.t / 1000).toFixed(2)}s</span>{' '}
              <strong>{entry.source}</strong> {entry.event}
              {entry.data !== undefined && <code> {JSON.stringify(entry.data).slice(0, 220)}</code>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default DebugPanel;
